export default {
      id: "additionalAccountFilters-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#additionalAccountFilters-usage",
      toString: function () {
        return this.url;
      }
    }